'use strict';

import { authAppState, defaultAppState } from '../App/app.states';

export const userRegistrationRootState = {
	parent: authAppState.name,
	name: 'userRegistrationRoot',
	url: '/registration',
	component: 'registrationForm',
	lazyLoad: async function (transition) {
		const $ocLazyLoad = transition.injector().get('$ocLazyLoad');
		const { UserRegistrationModuleLazy } = await import(/* webpackChunkName: "shell" */ './user-registration-lazy.module');
		await $ocLazyLoad.inject({
			rerun: true,
			reconfig: true,
			name: UserRegistrationModuleLazy.name,
		});

		const { shellAgentModule } = await import(/* webpackChunkName: "shell" */ '../Shell/shell');

		await $ocLazyLoad.inject(shellAgentModule.name, {}, true);
	},
};

export const ignoreUserRegistrationHook = {
	condition: (state) => {
		const authorized = isAuthorizedState(state);
		const toUserRegistration = toUserRegistrationState(state);
		return authorized && toUserRegistration;
	},
	hook: async (transition) => {
		const userProfileService = transition.injector().get('mx.shell.UserProfileService');
		const authService = transition.injector().get('mx.shell.AuthService');

		const signupEnabled = await authService.isSignUpEnabled();
		const userInfo = await userProfileService.get();

		if (userInfo.status !== 2027 || !signupEnabled) {
			return transition.router.stateService.target(defaultAppState.name, {});
		}
	},
	options: {
		priority: 20,
	},
};

export const redirectToUserRegistrationHook = {
	condition: (state) => {
		const authorized = isAuthorizedState(state);
		const toUserRegistration = toUserRegistrationState(state);
		return authorized && !toUserRegistration;
	},
	hook: async (transition) => {
		const $state = transition.injector().get('$state');
		const userProfileService = transition.injector().get('mx.shell.UserProfileService');
		const userInfo = await userProfileService.get();

		if (userInfo.status === 2027) {
			window.location.href = $state.href(userRegistrationRootState.name, {}, { absolute: true });
			await new Promise((resolve) => setTimeout(resolve, 1000));
		}
	},
	options: {
		priority: 20,
	},
};

function toUserRegistrationState(state) {
	return state.includes[userRegistrationRootState.name];
}

function isAuthorizedState(state) {
	return !state.data || (state.data && !state.data.isAnonymous);
}
